import {createAsyncThunk} from '@reduxjs/toolkit';
import api from 'services/axios';

export const getOrderDetails = createAsyncThunk<any, any>(
  'getOrdersDetails',
  async (orderId = 0) => {
    try {
      const res = await api.get(`order/products?orderId=${orderId}`);
      return {data: res.data, orderId};
    } catch (e: any) {
      console.warn(e);
    }
  }
);

//New Order API
export const getOrders = createAsyncThunk<any, any>('getOrders', async (params, thunkApi) => {
  try {
    const response = await api.get(`dasht/orders`, {
      params,
      goBaseUrl: true
    });
    return thunkApi.fulfillWithValue(response.data);
  } catch (e: any) {
    console.warn(e);
  }
});

export const getOrder = createAsyncThunk<any, any>('getOrder', async (params, thunkApi) => {
  try {
    const response = await api.get(`dasht/orders/${params.orderId}`, {
      params: {vendor_id: params.vendor_id},
      goBaseUrl: true
    });
    return thunkApi.fulfillWithValue(response.data);
  } catch (e: any) {
    console.warn(e);
  }
});

export const getOrdersReportNew = createAsyncThunk<any, any>(
  'getOrdersReportNew',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`dasht/orders/report`, {
        params,
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      console.warn(e);
    }
  }
);

export const getOrdersReportTrip = createAsyncThunk<any, any>(
  'getOrdersReportTrip',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`dasht/orders/report/${params.order_id}/trip`, {
        params,
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      console.warn(e);
    }
  }
);

export const getOrdersReportTripTracking = createAsyncThunk<any, any>(
  'getOrdersReportTripTracking',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`dasht/orders/report/${params.order_id}/trip/tracking`, {
        params,
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      console.warn(e);
    }
  }
);
